import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { TimeChallengeService } from 'src/app/services/time-challenge.service';
import { PopupModalComponent } from '../../shared/popup-modal/popup-modal.component';

@Component({
  selector: 'vex-time-challenge-user',
  templateUrl: './time-challenge-user.component.html',
  styleUrls: ['./time-challenge-user.component.scss']
})
export class TimeChallengeUserComponent implements OnInit {
  spinner: boolean = false;
  selectedWeek: number = 0;
  showChangeChall: boolean = false;

  constructor(public guiService: GuiService, private restService: RestService, public translate: TranslateService, public timeChallengeService: TimeChallengeService, private dialog: MatDialog) { }

  ngOnInit() {
    console.debug(this.timeChallengeService.challenge, this.timeChallengeService.showCountdown)
    if (this.guiService.userLogged) {
      this.showChangeChall = false;
      this.timeChallengeService.getLastTimeChallenge();
    }else {
      this.guiService.goTo('main/home');
    }
  }

  acceptChallenge(){
    const param = {
      userId: this.guiService.userLogged.user.id,
      challengeId: this.timeChallengeService.challenge._id,
      challengeNumber: this.timeChallengeService.selectedChallenge
    }
    this.spinner = true;
    this.restService.postService('node', '/accept-time-challenge', param).subscribe((ris) => {
      const today = moment();
      const endAcceptancePeriod = moment(this.timeChallengeService.challenge.startDate).add(this.timeChallengeService.challenge.acceptancePeriod, 'days');
      if (today.isSameOrBefore(endAcceptancePeriod, 'day')) {
        this.timeChallengeService.showCountdown = true;
        const countdownTime = this.timeChallengeService.challenge.challenges[this.timeChallengeService.selectedChallenge].weeks[0].publishDate;
        this.timeChallengeService.startCountdown(moment(countdownTime).diff(moment()));
      }
      this.timeChallengeService.acceptedChallenge = {
        userId: this.guiService.userLogged.user.id,
        challengeId: this.timeChallengeService.challenge._id,
        challengeNumber: this.timeChallengeService.selectedChallenge
      };
      this.timeChallengeService.selectedChallenge = this.timeChallengeService.selectedChallenge;
      this.showChangeChall = false;
      this.presentToast();
      this.guiService.goTo('main/home');
      this.spinner = false;
    })
  }

  presentToast() {
    this.guiService.openSnackBar(this.translate.instant("BANNER_CHALLENGE.CHALL_ACCEPTED"),'ok')
  }

  checkUnlockWeekDate(date){
    const unlockDate = moment(date);
    const today = moment();
    if(today.isBefore(unlockDate, 'day')){
      return true
    }else{
      return false
    }
  }

  openVideo(video){
    const item = JSON.stringify(video);
    sessionStorage.setItem('selectedTimeChallengeVideo', item);
    this.guiService.goTo('main/timechallenge-video');
  }

  checkVideosWatched(week, videoIndex, videoId){
    const videosWatched = localStorage.getItem('timeChallengeVideoWatched') ? JSON.parse(localStorage.getItem('timeChallengeVideoWatched')) : null;
    if(videosWatched){
      if(videosWatched['week_'+week]){
        if(videosWatched['week_'+week]['video_'+videoIndex] && videosWatched['week_'+week]['video_'+videoIndex] === videoId){
          return true
        }
        return false
      }
      return false
    }
    return false
  }

  setVideoWatched(vidIndex: number, weekIndex: number, vidId: string, videoName: string): void {
  this.dialog.open(PopupModalComponent, {
    width: '400px',
    disableClose: true,
    data: {
      title: videoName,
      subTitle: this.translate.instant("HOME.MODAL-MARK.SUB-TITLE-MARK"),
      buttonTitle: this.translate.instant("HOME.MODAL-MARK.BTN-CONFIRM"),
      closeBtnTop: true,
      callbackBtn: 'markVideo'
    },
    panelClass: 'custom-modal-home'
  }).afterClosed().subscribe((result) => {
    if (result?.callback === 'markVideo') {
      let videosWatched = localStorage.getItem('timeChallengeVideoWatched');
      videosWatched = videosWatched ? JSON.parse(videosWatched) : {};

      const weekKey = `week_${weekIndex}`;
      const videoKey = `video_${vidIndex}`;

      if (!videosWatched[weekKey]) {
        videosWatched[weekKey] = {};
      }

      videosWatched[weekKey][videoKey] = vidId;

      localStorage.setItem('timeChallengeVideoWatched', JSON.stringify(videosWatched));
    }
  });
}


}

